import { ErrorHandler, inject, Injectable, Injector } from '@angular/core';
import { FeedbackActivityRecorder } from './feedback-activity-recorder.service';

/** EXT-6172: records uncaught errors' messages for feedback context, then
 * defers to Angular's default handler so console output is unchanged.
 *
 * The recorder is resolved lazily: ErrorHandler is constructed during
 * bootstrap, and eagerly injecting a service that depends on Router
 * from here risks a circular-dependency error at startup. */
@Injectable()
export class FeedbackErrorHandler extends ErrorHandler {
  private readonly injector = inject(Injector);

  override handleError(error: unknown): void {
    try {
      this.injector.get(FeedbackActivityRecorder).recordConsoleError(error);
    } catch {
      // Never let context capture break error reporting itself.
    }
    super.handleError(error);
  }
}
